export function getAlignX(
  item1,
  item2,
  alignment = 'center',
  pad,
  screenHeight
) {
  switch (alignment) {
    case 'left':
      return getFixLeftX(item1, item2, pad, screenHeight);
    case 'right':
      return getFixRightX(item1, item2, pad, screenHeight);
    case 'center':
      return getCenterX(item1, item2);
  }
}

export function getReverseAlignX(item1, item2, alignment, pad, screenHeight) {
  const reversedAlignment = { left: 'right', right: 'left' };
  return getAlignX(
    item1,
    item2,
    reversedAlignment[alignment],
    pad,
    screenHeight
  );
}

export function getAlignY(
  item1,
  item2,
  alignment = 'center',
  pad,
  screenHeight
) {
  switch (alignment) {
    case 'top':
      return getFixTopY(item1, item2, pad, screenHeight);
    case 'bottom':
      return getFixBottomY(item1, item2, pad, screenHeight);
    case 'center':
      return getCenterY(item1, item2);
  }
}

export function getFixTopY(item1, item2, pad, screenHeight) {
  return (
    item2.y -
    getOffsetY(item2) +
    getOffsetY(item1) +
    getPadding(screenHeight, pad)
  );
}

export function getFixBottomY(item1, item2, pad, screenHeight) {
  return (
    item2.y +
    item2.height -
    getOffsetY(item2) +
    getOffsetY(item1) -
    item1.height -
    getPadding(screenHeight, pad)
  );
}

export function getFixRightX(item1, item2, pad, screenHeight) {
  return (
    item2.x +
    item2.width -
    getOffsetX(item2) +
    getOffsetX(item1) -
    item1.width -
    getPadding(screenHeight, pad)
  );
}

export function getFixLeftX(item1, item2, pad, screenHeight) {
  return (
    item2.x -
    getOffsetX(item2) +
    getOffsetX(item1) +
    getPadding(screenHeight, pad)
  );
}

export function getFixAboveY(item1, item2, pad, screenHeight) {
  return (
    item2.y -
    item1.height -
    getOffsetY(item2) +
    getOffsetY(item1) -
    getPadding(screenHeight, pad)
  );
}

export function getFixBelowY(item1, item2, pad, screenHeight) {
  return (
    item2.y +
    item2.height -
    getOffsetY(item2) +
    getOffsetY(item1) +
    getPadding(screenHeight, pad)
  );
}

export function getPadding(height = 0, percent = 0) {
  return height * (percent / 100);
}

export function getXAccountingForAnchor(item) {
  return item.x - getOffsetX(item);
}

export function getYAccountingForAnchor(item) {
  return item.y - getOffsetY(item);
}

export function getCenter(item1, item2) {
  return {
    x: getCenterX(item1, item2),
    y: getCenterY(item1, item2),
  };
}

export function getCenterX(item1, item2) {
  return (
    item2.x -
    getOffsetX(item2) +
    getOffsetX(item1) +
    (item2.width - item1.width) / 2
  );
}

export function getCenterY(item1, item2) {
  return (
    item2.y -
    getOffsetY(item2) +
    getOffsetY(item1) +
    (item2.height - item1.height) / 2
  );
}

export function getOffsetX(item) {
  return item.anchor ? item.anchor.x * item.width : 0;
}

export function getOffsetY(item) {
  return item.anchor ? item.anchor.y * item.height : 0;
}

export default {
  getAlignX,
  getReverseAlignX,
  getAlignY,
  getFixTopY,
  getFixBottomY,
  getFixRightX,
  getFixLeftX,
  getFixAboveY,
  getFixBelowY,
  getPadding,
  getCenter,
  getCenterX,
  getCenterY,
  getXAccountingForAnchor,
  getYAccountingForAnchor,
  getOffsetX,
  getOffsetY,
};
